export default "__VITE_ASSET__DOValvQk__"